import { Trans, useTranslation } from 'react-i18next';

import {
  LegalEmailLink,
  LegalIntro,
  LegalPageLayout,
  LegalParagraph,
  LegalSection,
  LegalSections,
} from '../components/legal/LegalPageLayout';

export const TermsPage = () => {
  const { t } = useTranslation('legal');

  return (
    <LegalPageLayout title={t('terms.title')} lastUpdated={t('shared.last_updated')}>
      <LegalIntro>
        <Trans ns="legal" i18nKey="terms.intro_p1" components={{ strong: <strong className="text-dark-invirtus" /> }} />
      </LegalIntro>
      <LegalIntro>{t('terms.intro_p2')}</LegalIntro>

      <LegalSections>
        <LegalSection title={t('terms.s1_title')}>
          <LegalParagraph>{t('terms.s1_p1')}</LegalParagraph>
          <LegalParagraph>{t('terms.s1_p2')}</LegalParagraph>
          <LegalParagraph>{t('terms.s1_p3')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s2_title')}>
          <LegalParagraph>{t('terms.s2_p1')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s3_title')}>
          <LegalParagraph>{t('terms.s3_p1')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s4_title')}>
          <LegalParagraph>{t('terms.s4_p1')}</LegalParagraph>
          <LegalParagraph>{t('terms.s4_p2')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s5_title')}>
          <LegalParagraph>{t('terms.s5_p1')}</LegalParagraph>
          <LegalParagraph>{t('terms.s5_p2')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s6_title')}>
          <LegalParagraph>{t('terms.s6_p1')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s7_title')}>
          <LegalParagraph>{t('terms.s7_p1')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s8_title')}>
          <LegalParagraph>{t('terms.s8_p1')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s9_title')}>
          <LegalParagraph>{t('terms.s9_p1')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s10_title')}>
          <LegalParagraph>{t('terms.s10_p1')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s11_title')}>
          <LegalParagraph>{t('terms.s11_p1')}</LegalParagraph>
        </LegalSection>

        <LegalSection title={t('terms.s12_title')}>
          <LegalParagraph>
            {t('terms.s12_p1_prefix')}{' '}
            <LegalEmailLink email="aida@invirtus.co" />
          </LegalParagraph>
        </LegalSection>
      </LegalSections>
    </LegalPageLayout>
  );
};
